import {
  GET_AUTH_INFO,
  GET_AUTH_INFO_ERROR,
  GET_AUTH_INFO_SUCCESS,
  GET_TOKEN,
  GET_TOKEN_ERROR,
  GET_TOKEN_SUCCESS
} from './AuthorizationProvider.actions'

const authorizationProviderState = {
  accessToken: undefined,
  authInfo: {
    error: undefined,
    isAdmin: false,
    isBaseSupplier: false,
    isValid: false,
    loading: false,
    orgCode: '',
    roles: undefined,
    userCode: '',
    userName: '',
    userType: ''
  },
  gettingToken: true,
  error: false
}

/**
 * The authorization provider's reducer.
 */
const authorizationProviderReducer = (state = authorizationProviderState, { payload, type }) => {
  switch (type) {
    case GET_AUTH_INFO: {
      return { ...state, authInfo: { ...state.authInfo, loading: true }, error: false }
    }
    case GET_AUTH_INFO_ERROR: {
      return { ...state, authInfo: { ...state.authInfo, error: payload.error, loading: false }, error: true }
    }
    case GET_AUTH_INFO_SUCCESS: {
      return {
        ...state,
        authInfo: { ...state.authInfo, ...payload.authInfo, isValid: true, loading: false },
        error: false
      }
    }
    case GET_TOKEN: {
      return { ...state, accessToken: undefined, error: false, gettingToken: true }
    }
    case GET_TOKEN_ERROR: {
      return { ...state, error: true, gettingToken: false }
    }
    case GET_TOKEN_SUCCESS: {
      return { ...state, accessToken: payload.accessToken, error: false, gettingToken: false }
    }
    default: {
      return state
    }
  }
}

export default authorizationProviderReducer
